import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "customer-button__name" };
import env from '../services/AppEnv';
import events from '@astina/paloma-common-ui/src/services/EventBus';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CustomerButton',
    props: {
        showSwitchIcon: { type: Boolean }
    },
    setup(__props) {
        const customer = env.customer;
        function showUserModal() {
            events.$emit('app.show-user-modal');
        }
        return (_ctx, _cache) => {
            const _component_icon = _resolveComponent("icon");
            return (_unref(customer).id)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (showUserModal()), ["prevent"])),
                    class: "customer-button"
                }, [
                    _createVNode(_component_icon, {
                        name: "building",
                        "icon-style": "light"
                    }),
                    _cache[1] || (_cache[1] = _createTextVNode()),
                    _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(customer).company), 1),
                    _cache[2] || (_cache[2] = _createTextVNode()),
                    (__props.showSwitchIcon)
                        ? (_openBlock(), _createBlock(_component_icon, {
                            key: 0,
                            name: "repeat",
                            "icon-style": "light"
                        }))
                        : _createCommentVNode("", true)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
